import type { Certification, Education } from '@portfolio/shared';

/**
 * Newest first, with undated entries last.
 *
 * Credential IDs and expiry dates are intentionally absent: none were supplied.
 * `awardedOn` is set only where a certificate document records the date.
 */
export const certifications: readonly Certification[] = [
  {
    id: 'globallogic-ai-associate',
    // Title exactly as printed on the certificate.
    name: 'AI 101: GL Certified AI Associate - Developers',
    issuer: 'GlobalLogic',
    year: 2026,
    awardedOn: '2026-07-30',
  },
  {
    id: 'aws-developer-associate',
    name: 'AWS Certified Developer - Associate',
    issuer: 'Amazon Web Services',
    year: 2022,
  },
  {
    id: 'cambridge-c1',
    name: 'Cambridge English C1 Advanced',
    issuer: 'Cambridge Assessment English',
    year: 2021,
  },
  {
    id: 'globallogic-generative-ai',
    name: 'Generative AI',
    issuer: 'GlobalLogic',
    year: null,
  },
  {
    id: 'globallogic-agentic-ai',
    name: 'Agentic AI with LangChain and Langflow',
    issuer: 'GlobalLogic',
    year: null,
  },
];

export const education: readonly Education[] = [
  {
    id: 'msc-computer-science',
    qualification: 'MSc in Computer Science',
    institution: 'Alexandru Ioan Cuza University of Iasi',
    location: 'Iasi, Romania',
  },
];
